import { http, withoutAccessHttp } from '../http-common';

export type AuthTokenResponse = {
  accessToken: string;
  accessTokenExpiredAt: string;
  refreshToken: string;
  refreshTokenExpiredAt: string;
};

export type ImpersonationTokenResponse = { tokenId: string };

const loginByAccountId = (accountId: number | string) =>
  http.post<ImpersonationTokenResponse>('/auth/login/by-accountId', undefined, {
    params: { accountId },
  });

const loginByTokenId = (tokenId: string) =>
  withoutAccessHttp.post<AuthTokenResponse>('/auth/login/by-tokenId', { tokenId });

const AuthService = { loginByAccountId, loginByTokenId };

export default AuthService;

